export const importAllModels = async () => {
	const modules = import.meta.glob([
		'../modelx/models/private/*',
		'../modelx/models/private/*/*',
		'../modelx/models/public/*',
		'../modelx/models/public/*/*',
	]);

	await Promise.all(Object.values(modules).map(module => module()));
};